<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="entries"
      :page.sync="pagination.page"
      :items-per-page="pagination.rowsPerPage"
      :items-per-page-text="$t('tables.RowsPerPage')"
      :items-per-page-items="[5, 10]"
      :header-props="{ sortIcon: 'mdi-menu-down' }"
      :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right' }"
      style="width: 100%"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.bt_num_pol }}</td>
          <td>{{ props.item.bt_floor }}</td>
          <td>{{ props.item.bt_fraction }}</td>
          <td>{{ getTypeName(props.item.bt_type) }}</td>
          <td>{{ props.item.bt_description }}</td>
          <td>{{ props.item.bt_address }}</td>
          <td v-if="!disabled">
            <app-datatable-action-buttons
              :user-can-edit="true"
              @edit="startEditingItem(props.item)"
              :user-can-delete="true"
              @delete="deleteItem(props.item)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>

    <typification-edition-dialog
      v-if="itemEditionDialog"
      :open="itemEditionDialog"
      :original-item="itemToEdit"
      @close="closeItemEdition"
      @edit="editItem"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import TypificationEditionDialog from "@/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationEditionDialog";
import { listsMixin } from "@/mixins/listsMixin";

export default {
  name: "TypificationTable",

  components: { TypificationEditionDialog, AppDatatableActionButtons },

  mixins: [listsMixin],

  props: {
    entries: {
      type: Array,
      required: true
    },

    disabled: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      typeOptions: [],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },

      itemEditionDialog: false,
      itemIndex: null
    };
  },

  computed: {
    headers() {
      let headers = [
        { text: this.$i18n.tc("Number", 1), value: "bt_num_pol" },
        { text: this.$i18n.tc("Floor", 1), value: "bt_floor" },
        { text: this.$i18n.tc("Fraction", 1), value: "bt_fraction" },
        { text: this.$i18n.tc("Type", 1), value: "bt_type" },
        { text: this.$i18n.t("Description"), value: "bt_description" },
        { text: this.$i18n.tc("Address", 1), value: "bt_address" }
      ];
      if (!this.disabled) {
        headers.push({ text: "", value: "", width: "5%" });
      }
      return headers;
    },

    itemToEdit() {
      if (this.itemIndex !== null) {
        return this.entries[this.itemIndex];
      }
      return {};
    }
  },

  created() {
    this.loadTypeOptions();
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    loadTypeOptions() {
      let listName = "list_bd_category_type";
      this.typeOptions = this.$store.getters.getListOfOptionsByListName(
        listName,
        [],
        true
      );
      if (this.typeOptions === undefined) {
        this.GET_LIST({ listName: listName, code: [], includeDeleted: true })
          .then(list => {
            this.typeOptions = list;
          })
          .catch(() => {
            this.typeOptions = [];
          });
      }
    },

    getTypeName(typeID) {
      let typeName = typeID;
      if (this.typeOptions.length > 0) {
        let type = this.typeOptions.find(item => item.code === typeID);
        if (type) {
          typeName = this.getListElementLabel(type);
        }
      }
      return typeName;
    },

    startEditingItem(typificationItem) {
      this.itemIndex = this.entries.findIndex(
        item => item === typificationItem
      );
      this.itemEditionDialog = true;
    },

    editItem(updatedItem) {
      this.$emit("update-item", { index: this.itemIndex, item: updatedItem });
    },

    closeItemEdition() {
      this.itemEditionDialog = false;
      this.itemIndex = null;
    },

    deleteItem(typificationItem) {
      let itemIndex = this.entries.findIndex(item => item === typificationItem);
      this.$emit("delete", itemIndex);
    }
  }
};
</script>

<style>
#typification-tab table.v-table tbody td:first-child,
#typification-tab table.v-table thead th:first-child {
  padding-left: 10px;
}

#typification-tab table.v-table tbody td:first-child,
#typification-tab table.v-table tbody td:not(:first-child),
#typification-tab table.v-table tbody th:first-child,
#typification-tab table.v-table tbody th:not(:first-child),
#typification-tab table.v-table thead td:first-child,
#typification-tab table.v-table thead td:not(:first-child),
#typification-tab table.v-table thead th:first-child,
#typification-tab table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

#typification-tab table.v-table thead tr,
#typification-tab table.v-table tbody td,
#typification-tab table.v-table tbody th,
#typification-tab .v-datatable__actions {
  height: 40px;
}

#typification-tab .v-datatable__actions__select .v-select {
  margin: 0 0 0 34px;
}

#typification-tab .v-datatable__actions__range-controls {
  min-height: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationTable.vue